import { Path, HcSparrowHawk } from "@dev/hc-talk-talk";

export default class BasePath extends Path {
    constructor(primary: string, useAuthorizationToken: boolean = false) {
        super({
            primary,
            secondary: primary,
            secondaryBaseUrl: `http://localhost:${HcSparrowHawk.port}/api/loki/`,
            useAuthorizationToken
        });
    }
}
